import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentsConfigsModule } from '@epicuro-next/platform/dynamic-components-configs';
import { DynamicLogicalOperationsModule } from '@epicuro-next/platform/dynamic-logical-operations';
import { DynamicValueResolvingModule } from '@epicuro-next/platform/dynamic-value-resolving';

import { CollectionsRendererComponent } from './components/collections-renderer/collections-renderer.component';
import { DynamicCollectionsOutletComponent } from './components/dynamic-collections-outlet/dynamic-collections-outlet.component';
import { DynamicLayoutBuilderComponent } from './components/dynamic-layout-builder/dynamic-layout-builder.component';
import { DynamicComponentDirective } from './directives/dynamic-component.directive';
import { ComponentsResolverService } from './services/components-resolver.service';
import { ComponentsStylesResolverService } from './services/components-styles-resolver.service';
import { FetchConfigFromCodeService } from './services/config-fetchers/fetch-config-from-code.service';
import { FetchConfigFromRuleEngineService } from './services/config-fetchers/fetch-config-from-rule-engine.service';
import {
  FetchConfigService,
  FETCH_CONFIG_SERVICES,
} from './services/fetch-config.service';

const dynamicComponents = [
  DynamicLayoutBuilderComponent,
  CollectionsRendererComponent,
];

@NgModule({
  imports: [
    CommonModule,
    DynamicComponentsConfigsModule,
    DynamicLogicalOperationsModule,
    DynamicValueResolvingModule,
  ],
  declarations: [
    DynamicComponentDirective,
    ...dynamicComponents,
    DynamicCollectionsOutletComponent,
  ],
  providers: [
    ComponentsResolverService,
    ComponentsStylesResolverService,
    FetchConfigService,
    FetchConfigFromCodeService,
    FetchConfigFromRuleEngineService,
    {
      provide: FETCH_CONFIG_SERVICES,
      useClass: FetchConfigFromCodeService,
      multi: true,
    },
    {
      provide: FETCH_CONFIG_SERVICES,
      useClass: FetchConfigFromRuleEngineService,
      multi: true,
    },
  ],
  exports: [
    DynamicComponentDirective,
    ...dynamicComponents,
    DynamicCollectionsOutletComponent,
  ],
})
export class DynamicComponentsModule {}

dynamicComponents.forEach((component) => DontTreeShake(component));
